const trips = {
  trips: 'נסיעות',
  stopTypes: {
    charging: '',
    cluster: '(מרכז אשכול)',
  },
  statuses: {
    new: 'חדש',
    in_route: 'בנסיעה',
    sent: 'נשלח',
    approved: 'מאושר',
    done: 'בוצע',
    canceled: 'בוטל',
  },
  driverActions: {
    more: 'עוד',
    send: 'שלח',
    call: 'חייג',
    note: 'הערה',
  },
  moreActions: {
    actions: 'עוד',
    sendTrip: {
      title: 'שלח נסיעה',
      body: 'אתה עומד לשלוח {{tripsCount}} נסיעות.',
    },
    delete: {
      title: 'מחק',
      body: 'אתה עומד למחוק {{tripsCount}} נסיעות.',
    },
    addNote: {
      title: 'הוסף הערה',
      body: 'אתה עומד להוסיף הערה ל{{tripsCount}} נסיעות.',
    },
    showOnMap: 'הצג על המפה',
    sendMessage: {
      title: 'שלח הודעה',
      body: 'אתה עומד לשלוח הודעה ל{{tripsCount}} נהגים.',
    },
    merge: {
      title: 'מזג נסיעות',
      body: 'אתה עומד למזג {{tripsCount}} נסיעות.',
    },
    cancelTrip: {
      title: 'בטל נסיעה',
      body: 'אתה עומד לבטל {{tripsCount}} נסיעות.',
    },
    export: 'ייצא',
    tripReports: 'דוחות נסיעות',
    clearAssinment: {
      title: 'נקה ציוותים',
      body: 'אתה עומד לנקות ציוותים עבור {{tripsCount}} נסיעות.',
      confirmButton: 'אישור',
      checkBoxSkipManuallyAssigned: 'דלג על שיוכים ידניים בממשק זה',
    },
    clearBlacklistedDrivers: {
      title: 'לנקות נהגים חסומים?',
      body: 'פעולה זו תסיר נהגים חסומים כלשהם מהנסיעות שנבחרו ומההזמנות המשויכות אליהן, אך לא תשנה את שיוכי הנהגים הקיימים.',
      toastSuccess: 'הנהגים החסומים נוקו בהצלחה.',
    },
    exportToKml: {
      title: 'ייצא KMLs',
      body: 'אתה עומד לייצא קבצי KML עבור {{tripsCount}} נסיעות.',
    },
    exportTripDirections: {
      title: 'ייצוא הנחיות נסיעה',
      body: 'אתה עומד לייצא קבצי Excel עבור {{tripsCount}} נסיעות.',
    },
    exportToOptibus: {
      body: 'בחר פרויקט Optibus לייצוא הנסיעות אליו:',
    },
  },
  tripInfo: {
    title: 'נסיעה ',
    formTabs: {
      detailsTab: 'פרטים',
      historyTab: 'היסטוריה',
      assignInsightsTab: 'דו״ח ציוותים',
      analysis: 'ניתוח נסיעה',
      feedback: 'משוב',
    },
    driverActions: {
      note: 'הערה',
      call: 'חייג',
      send: 'שלח',
      more: 'עוד',
    },
    toast: {
      assignment: 'נסיעה שצוותה בהצלחה',
      toastSomethingWasWrong: 'משהו השתבש',
      toastActionEndTrip: 'סיום נסיעה זמין כאשר כל הנוסעים הורדו',
    },
    selectDriver: 'בחר נהג',
    selectVehicle: 'בחר רכב',
    bookingDetails: {
      title: 'פרטי הזמנה',
    },
    status: 'סטטוס',
    headerBreakDown: 'פירוט נסיעה',
    driverNotAssigned: 'נהג לא צוות',
    vehicleNotAssigned: 'רכב לא צוות',
    noDriver: 'אין נהג',
    noCar: 'אין רכב',
    noService: 'אין שירות',
    seats: 'מושבים',
    originalStation: 'Original Station: ',
    newStation: 'New Station: ',
    moveStopHeader: 'אתה עומד להזיז עצירה בנסיעה: {{ tripId }}',
    date: 'תאריך',
    pickupTime: 'שעת איסוף',
    eta: 'זמן הגעה משוער לעצירה הבאה',
    passengers: 'נוסעים',
    stops: 'עצירות',
    distance: 'מרחק',
    miles: 'מייל',
    kilometers: 'ק"מ',
    accept: 'קבל',
    decline: 'דחה',
    map: {
      switchRoute: {
        toasts: {
          success: 'המסלול הוחלף בהצלחה',
          failure: 'אירעה שגיאה בהחלפת המסלול',
        },
      },
      operators: {
        fetchError: 'לא ניתן לאחזר מפעילים',
        placeholder: 'מפעילים',
        submit: {
          toasts: {
            success: 'המפעילים עודכנו בהצלחה',
            error: 'לא ניתן לעדכן מפעילים',
          },
        },
      },
      stopClusterDistance: '  ( {{distance}}מ לנק׳ איסוף)',
    },
    modalEndTrip: {
      body: 'אנא סמן את כל הנוסעים כהורדו',
      header: 'אזהרה!',
    },
    tripActions: {
      tripBreakdown: 'פירוט נסיעה',
      note: 'הוסף הערה',
      history: 'היסטוריה',
      msg: 'שלח הודעה לנהג',
      moveToCustomRulesLabel: 'צור חוק מותאם אישית',
      start: {
        name: 'התחל נסיעה',
        title: 'פעולה זמינה עבור סטטוס מאושר',
      },
      end: {
        name: 'סיים נסיעה',
        title: 'סיום נסיעה זמין כאשר כל הנוסעים הורדו',
      },
      cancel: 'בטל נסיעה',
      breakdown: 'פירוט נסיעה',
    },
    stopActions: {
      queue: 'הוסף לתור',
    },
    passengerActions: {
      queue: 'הוסף לתור',
    },
    assignLog: {
      button: 'מידע ציוותים',
      closeButton: 'יומן ציוותים',
      table: {
        headers: {
          driver: 'נהג',
          vehicle: 'רכב',
          score: 'ציון',
          flag: 'דגל',
          minutes: 'דקות',
          radius: 'רדיוס',
          seatCount: 'מספר מושבים',
          totalTrips: 'סה"כ נסיעות',
          totalPrice: 'מחיר כולל',
        },
      },
    },
    breakdown: {
      table: {
        headers: {
          id: 'מזהה',
          planned: 'זמן מתוכנן',
          date: 'זמן מבוקש',
          passenger: 'נוסע',
          type: 'סוג',
          from: 'מ-',
          to: 'אל',
          vin: 'מספר שלדה',
          make: 'יצרן',
          model: 'מודל',
          year: 'שנה',
          weight: 'משקל',
          height: 'גובה',
          width: 'רוחב',
          length: 'אורך',
          price: 'מחיר',
        },
      },
    },
    tripsInfoPlans: {
      toastStatusChanged: 'הסטטוס השתנה',
      toastStopRemoved: 'עצירה הוסרה',
      toastTripRemoved: '[נסיעות] הוסרו בהצלחה',
      toastTripRemoveError: '[נסיעות] לא ניתן להסיר',
      toastClearSuccess: '[נסיעות] נהגים ורכבים נוקו בהצלחה',
      toastClearError: '[נסיעות] נהגים ורכבים נוקו בהצלחה',
      toastTripCanceled: '[נסיעות] בוטלו בהצלחה',
      toastTripCanceledError: '[נסיעות] לא ניתן לבטל',
      toastJobRemoved: 'ההזמנה הוסרה',
      toastJobCanceld: 'ההזמנה בוטלה בהצלחה',
      toastSomethingWasWrong: 'משהו השתבש',
      toastMergeSuccess: 'הנסיעות מוזגו בהצלחה',
      toastMergeManyLockedAssignments: 'לא ניתן למזג נסיעות מכיוון שיש להן ציוותים נעולים שונים',
      toastMergeError: 'אחת מהנסיעות אינה זמינה למיזוג',
      btnRemoveStop: 'הסר',
      reservationActions: {
        btnPickUp: {
          name: 'נאסף',
          title: 'זמין רק עבור סטטוס "בנסיעה"',
        },
        btnDroppoff: {
          name: 'הורד',
          title: 'זמין רק עבור סטטוס "בנסיעה"',
        },
        btnNoShow: {
          name: 'לא הופיע',
          title: 'זמין רק עבור סטטוס "בנסיעה"',
        },
        btnCancel: 'בטל הזמנה',
        btnRemove: 'הסר מהנסיעה',
      },
    },
    events: {
      chargingStationAdded: 'תחנת טעינה נוספה',
    },
    moveReservation: {
      successToast: 'ההזמנה הועברה בהצלחה',
      errorToast: 'העברת ההזמנה נכשלה',
    },
    moveStops: {
      successToast: 'העצירות סודרו מחדש בהצלחה',
      errorToast: 'סידור מחדש של העצירות נכשל',
    },
  },
  edit: {
    applyingEditChanges: 'מבצע שינויים',
    progress: {
      toastSuccess: 'נקודות מעבר נשמרו',
      toastError: 'נכשל ביישום נקודות המעבר',
    },
    unsaved: {
      header: 'שינויים שלא נשמרו',
      body: 'יש לך שינויים שלא נשמרו. מה ברצונך לעשות?',
      confirm: 'בטל שינויים',
      cancel: 'השאר את השינויים',
    },
  },
  table: {
    floatingActions: {
      tooltips: {
        deleteNotNew: 'לפחות נסיעה אחת אינה במצב חדש',
        noPermission: 'הפעולה אינה מותרת: נדרשת הרשאה',
        accept: 'פעולה זו זמינה רק עבור נסיעות עם סטטוס `Accept` או `Decline`.',
        decline: 'פעולה זו זמינה רק עבור נסיעות עם סטטוס `Accept` או `Decline`.',
      },
      assign: 'צוות',
      send: 'שלח',
      cancel: 'בטל',
      delete: 'מחק',
      export: 'ייצא',
      merge: 'מזג',
      sendMessage: 'שלח הודעה',
      tripReport: 'דוח נסיעה',
      showOnMap: 'הצג על המפה',
      addNote: 'הוסף הערה',
      exportToKml: 'ייצא ל-KML',
      exportTripDirections: 'ייצוא הנחיות נסיעה',
      exportToOptibusPlanning: 'ייצוא לתכנון',
      exportToOptibusScheduling: 'ייצוא לתזמון',
      accept: 'קבל',
      decline: 'דחה',
    },
    filters: {
      status: 'סטטוס',
      profile: 'פרופילים',
      attributes: 'מאפיינים',
      supplier: 'ספקים',
      driver: 'נהג',
      vehicle: 'רכב',
      from: 'מ-',
      to: 'אל',
      locations: 'תחנות',
      airportLocations: 'מיקומי שדה תעופה',
      flightNumber: 'מספר טיסה',
      airline: 'חברת תעופה',
      flightStatus: 'סטטוס טיסה',
      productionId: 'מספר הפקה',
      drivers: {
        onlyWithout: 'נסיעות ללא ציוות',
        onlyWith: 'נסיעות שצוותו',
        all: 'מצוותות ולא מצוותות',
      },
      vehicles: {
        onlyWithout: 'רכב לא מצוות',
        onlyWith: 'רכב מצוות',
        all: 'מצוותות ולא מצוותות',
      },
      areas: 'אזורים',
    },
    buttons: {
      driver: 'נהג',
      vehicle: 'רכב',
    },
    statuses: {
      new: 'חדש',
      inRoute: 'בנסיעה',
      sent: 'נשלח',
      approved: 'מאושר',
      pickingUp: 'אוסף',
      done: 'בוצע',
      canceled: 'בוטל',
    },
    indicators: {
      consistentPassengerRouting: 'ניתוב עקבי לנוסעים',
      error: 'חקירה',
      manualDispatched: 'שיבוץ ידני',
    },
    headers: {
      id: 'מזהה',
      indicators: 'אינדיקטורים',
      status: 'סטטוס',
      date: 'תאריך',
      from: 'מ-',
      to: 'אל',
      seats: 'מושבים',
      passenger: 'נוסע',
      profile: 'פרופיל',
      stops: 'עצירות',
      distance: 'מרחק',
      duration: 'משך',
      service: 'שירות',
      flightInfo: 'פרטי טיסה',
      flightNumber: 'מספר טיסה',
      airline: 'חברת תעופה',
      scheduledFlightTime: 'זמן טיסה מתוכנן',
      actualFlightTime: 'זמן טיסה בפועל',
      flightStatus: 'סטטוס טיסה',
      supplier: 'ספק',
      driver: 'נהג',
      car: 'רכב',
      actions: 'פעולות',
      attr: 'מאפיינים',
      externalId: 'מזהה חיצוני',
      waitUntil: 'המתן עד',
      line: 'קו',
      cost: 'עלות',
      reservationsExtendUntilDate: 'המתן עד',
      areas: 'אזורים',
    },
    footer: {
      totalSeats: 'סה"כ מושבים: {{seats}}',
    },
    cells: {
      isTwoWay: {
        toolTip: 'דו-כיווני',
      },
      shared: {
        toolTip: 'נסיעה משותפת',
      },
      waitAndReturn: {
        toolTip: 'המתן וחזור',
      },
      merged: {
        toolTip: 'נסיעה מאוחדת',
      },
      chargingStops: {
        toolTip: 'עצירות טעינה',
      },
      manualAssignment: {
        integration: {
          toolTip: 'צוות ידנית (אינטגרציה)',
        },
        noIntegration: {
          toolTip: 'צוות ידנית',
        },
      },
      bypassed: {
        toolTip: 'הגדרות עקפו על ידי פעולה ידנית',
      },
      isManuallyAltered: {
        toolTip: 'סידור ידני',
      },
      car: {
        none: 'אין רכבים',
      },
      driver: {
        none: 'אין נהג',
      },
      supplier: {
        none: 'אין ספק',
      },
      actions: {
        approve: 'לאשר',
        remove: 'להסיר',
      },
    },
    actions: {
      autoAssign: {
        modal: {
          header: 'סיכום הקצאה',
          body: {
            trips: {
              total: 'סך כל הנסיעות',
              assigned: 'סך הכל מוקצה',
              unassigned: 'לא מוקצה',
            },
            drivers: {
              autoAssigned: 'מוקצה אוטומטית',
              preAssigned: 'מוקצה מראש',
              total: 'סך כל הנהגים',
              totalDriversAssigned: 'סך הכל מוקצה',
              unassigned: 'לא מוקצה',
              assignmentTime: 'זמן תהליך ההקצאה',
            },
            vehicles: {
              total: 'סך כל הרכבים',
              used: 'סך הכל מוקצה',
            },
            insights: {
              title: 'תובנות הקצאה',
              avgDistance: 'מרחקי נסיעה ממוצעים',
              avgDistanceToPickup: 'מרחק נסיעה ממוצע ריק',
              avgDuration: 'משך נסיעה ממוצע',
              avgDurationToPickup: 'משך נסיעה ממוצע ריק',
              avgPrice: 'מחיר ממוצע',
              waitAvg: 'זמן המתנה ממוצע',
            },
          },
        },
        errorModal: {
          header: 'שגיאה',
          body: 'כל הנסיעות שנבחרו כבר צוותו. כדי לצוות מחדש נהגים\nאנא נקה תחילה את הציוות הנוכחי.',
        },
      },
      assign: {
        assign: 'צוות',
        clearDriversVehicle: 'נקה נהגים/רכבים',
        clearBlacklistedDrivers: 'נקה נהגים חסומים',
        advancedAssign: 'ציוות מתקדם',
        modalHeader: 'צוות נסיעות',
        youAreAboutToAssign: 'אתה עומד לצוות נהגים ל{{numberOfTrips}} נסיעות.',
      },
      merge: {
        errorMessage: 'לא נמצאה נסיעה נוספת למיזוג',
        shuttle: 'לא ניתן למזג נסיעות שאטל',
      },
      showOnMap: {
        header: 'הצג על המפה',
        shuttle: 'לא ניתן למזג נסיעות שאטל',
      },
      export: {
        optibus: {
          header: 'פרויקטים',
          placeholder: 'בחר פרויקט',
          export: 'ייצא',
          success: 'הנסיעות שנבחרו נשלחו בהצלחה לפרויקט Optibus הנבחר.',
        },
      },
      cancelReservation: 'אתה עומד לבטל הזמנה זו',
      report: {
        header: 'סיכום מסלול',
        body: {
          totalTrips: 'נסיעות',
          totalCost: 'עלות',
          totalPrice: 'מחיר',
          totalJobs: 'הזמנות',
          totalDuration: 'משך',
          totalDistance: 'מרחק',
          totalAssigned: 'צוות',
          totalUnassigned: 'ללא ציוות',
          totalDrivers: 'נהגים',
          averageJobs: 'ממוצע הזמנות',
          averageDistance: 'מרחק ממוצע',
          averageDuration: 'משך ממוצע',
        },
      },
    },
  },
};

export default trips;
